import {Pipe, PipeTransform} from '@angular/core';
import {OrderAppointmentStatus} from "@services";

@Pipe({
    name: 'orderAppointmentStatus',
    standalone: true
})
export class OrderAppointmentStatusPipe implements PipeTransform {
    transform(value: OrderAppointmentStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case OrderAppointmentStatus.NoAppointmentAssigned: return "No Appointment Assigned";
            case OrderAppointmentStatus.AppointmentAssigned: return "Appointment Assigned";
            case OrderAppointmentStatus.AppointmentConfirmed: return "Appointment Confirmed";
            case OrderAppointmentStatus.LtlLoad: return "LTL Load";
            case OrderAppointmentStatus.ManualAppointmentSet: return "Manual Appointment Set";

            default: return value;
        }
    }
}
